'use client'

import Helper from "./helper";
import { getCurrentLocale } from "./localeHelper";
import { createIntl, createIntlCache } from 'react-intl';

const cache = createIntlCache();
let localeHelper = getCurrentLocale();
const intl = createIntl(
    {
        locale: localeHelper.locale,
        messages: localeHelper.message,
        onError: (err) => {
            if (err.code === 'MISSING_TRANSLATION') {
                console.log("missing translation", err.descriptor.id)
            } else {
                console.error(err);
            }
        }
    },
    cache
);

const formatMsg = (key: string, opt?, firebase?) => {
    if ((key === "USER") && Helper.getSelectedUserTypeName(firebase)) return Helper.getSelectedUserTypeName(firebase)
    return intl.formatMessage({ id: key, defaultMessage: key }, opt);
};

export default formatMsg;
